import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { AuthData } from '@tesla/ng-auth';
import { LanguageService } from 'app/core/services/language.service';
import { GetSupplierProfileCurrentUser } from 'app/profile/store/app.actions';
import { SelectCurrentUser } from 'app/profile/store/app.selector';
import { SupplierState } from 'app/profile/store/state/supplierstate.state';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ShellGuard implements CanActivate {
  private readonly languageRegex = /[a-z]{2}-[A-Z]{2}/g;

  constructor(
    private store: Store<SupplierState>,
    private languageService: LanguageService,
    private authData: AuthData
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    this.store.dispatch(new GetSupplierProfileCurrentUser());
    return this.authData.getAccessTokenAsync().map(
      res => {
        if (res) {
          this.store.pipe(
            select(SelectCurrentUser),
            filter(x => !!x)).subscribe(user => {
              const lang = localStorage.getItem('ttp-locale');
              if (!lang?.match(this.languageRegex)) {
                this.languageService.changeLanguage(user?.supplierContact?.languageCode || 'en-US');
              } else {
                this.languageService.changeLanguage(lang);
              }
            });
          return true;
        } else {
          return false
        }
      }
    )
  }

}
